import React from "react";

interface AnimatedBackgroundProps {
  variant?: "home" | "login" | "dashboard";
}

const AnimatedBackground: React.FC<AnimatedBackgroundProps> = ({ 
  variant = "home" 
}) => {
  const getElements = () => {
    switch (variant) {
      case "home":
        return (
          <>
            <div className="absolute top-20 left-20 w-32 h-32 bg-blue-500/10 rounded-full animate-pulse"></div>
            <div
              className="absolute top-40 right-32 w-24 h-24 bg-indigo-500/10 rounded-full animate-bounce"
              style={{ animationDelay: "1s" }}
            ></div>
            <div
              className="absolute bottom-32 left-40 w-20 h-20 bg-purple-500/10 rounded-full animate-pulse"
              style={{ animationDelay: "2s" }}
            ></div>
            <div
              className="absolute bottom-20 right-20 w-28 h-28 bg-pink-500/10 rounded-full animate-bounce"
              style={{ animationDelay: "0.5s" }}
            ></div>
            <div
              className="absolute top-1/2 left-10 w-16 h-16 bg-cyan-500/10 rounded-full animate-pulse"
              style={{ animationDelay: "1.5s" }}
            ></div>
            <div
              className="absolute top-1/4 right-10 w-12 h-12 bg-yellow-500/10 rounded-full animate-bounce"
              style={{ animationDelay: "2.5s" }}
            ></div>
          </>
        );
      
      case "login":
        return (
          <>
            <div className="absolute top-20 left-20 w-40 h-40 bg-blue-500/10 rounded-full animate-pulse"></div>
            <div
              className="absolute top-40 right-32 w-32 h-32 bg-indigo-500/10 rounded-full animate-bounce"
              style={{ animationDelay: "1s" }}
            ></div>
            <div
              className="absolute bottom-32 left-40 w-24 h-24 bg-purple-500/10 rounded-full animate-pulse"
              style={{ animationDelay: "2s" }}
            ></div>
            <div
              className="absolute bottom-20 right-20 w-36 h-36 bg-pink-500/10 rounded-full animate-bounce"
              style={{ animationDelay: "0.5s" }}
            ></div>
            <div
              className="absolute top-1/2 left-10 w-20 h-20 bg-cyan-500/10 rounded-full animate-pulse"
              style={{ animationDelay: "1.5s" }}
            ></div>
          </>
        );
      
      case "dashboard":
        return (
          <>
            <div className="absolute top-10 left-10 w-20 h-20 bg-primary-500/10 rounded-full animate-pulse"></div>
            <div
              className="absolute top-32 right-20 w-16 h-16 bg-blue-500/10 rounded-full animate-bounce"
              style={{ animationDelay: "1s" }}
            ></div>
            <div
              className="absolute bottom-20 left-32 w-12 h-12 bg-green-500/10 rounded-full animate-pulse"
              style={{ animationDelay: "2s" }}
            ></div>
            <div
              className="absolute bottom-40 right-10 w-24 h-24 bg-purple-500/10 rounded-full animate-bounce"
              style={{ animationDelay: "0.5s" }}
            ></div>
          </>
        );
      
      default:
        return null;
    }
  };

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {getElements()}
    </div>
  );
};

export default AnimatedBackground;
